import { Close } from "@mui/icons-material";
import { Dialog, IconButton } from "@mui/material";
import React from "react";

import useWindowDimensions from "../../hooks/useWindowDimensions";

export default function ModalShell({
  open,
  setOpen,
  customCloseFunc,
  color,
  title,
  customWidth,
  fullScreen,
  fullWidth = false,
  children,
}) {
  const { width } = useWindowDimensions();

  return (
    <Dialog
      open={open}
      fullScreen={fullScreen || width < 765 ? true : false}
      fullWidth={fullWidth}
      maxWidth={customWidth ? customWidth : "lg"}
    >
      <div
        className="overflow-y-auto [&::-webkit-scrollbar-thumb]:bg-blue-700 [&::-webkit-scrollbar]:[width:6px]"
        style={{
          padding: 20,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            fontSize: "20px",
          }}
        >
          <IconButton onClick={() => (!customCloseFunc ? setOpen(false) : customCloseFunc())}>
            <Close />
          </IconButton>
        </div>
        {title ? (
          <h1
            style={{
              fontSize: 20,
              color: color,
              margin: "0 0 1rem 0",
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            {title}
          </h1>
        ) : null}
        {children}
      </div>
    </Dialog>
  );
}
